import { createContext } from 'react';

import type { TagsSelectContextType } from '../../utils/types/stateful-list.types';

export const TagsSelectContext = createContext<TagsSelectContextType | null>(null);
